import { defineStore } from "pinia";
import { useRouter } from "vue-router";
interface UserInfo {
  tenantId?: string;
  [key: string]: any;
}

interface UserState {
  token: string;
  userInfo: UserInfo;
}

export const userStore = defineStore({
  id: "user",
  persist: true,
  state: (): UserState => ({
    token: "",
    userInfo: {},
  }),
  getters: {
    getToken(): string {
      return this.token;
    },
    isLogin(): boolean {
      return !!this.token;
    },
  },

  actions: {
    login(data: any) {
      const { token } = data;
      this.token = token;
      this.userInfo = data;
    },
    setToken(token: string) {
      this.token = token;
      localStorage.setItem("token", token);
    },
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
    },
    loginOut() {
      this.$reset();
    },
  },
});
